import { Duvidas } from "./style";
import DuvImgDesktop from "../../../../assets/duvidas-desktop.webp";
import DuvImgMobile from "../../../../assets/duvidas-mobile.webp";

function DuvidasComponent() {
  const { innerWidth } = window;

  return (
    <Duvidas>
      <div id="pather-div">
        <div id="duvidas-img">
          <figure>
            <img src={innerWidth < 601 ? DuvImgMobile : DuvImgDesktop} alt="" />
          </figure>
        </div>
        <div id="duvidas-text">
          <div id="duv-one">
            <span>ainda há dúvidas? 🧐</span>
            <h1>Veja esse comparativo com o que o mercado oferece..</h1>
          </div>
          <div id="duv-two">
            <div className="aulas">
              <h3>Aulas em grupo:</h3>
              <p>
                Valor anual médio para cursos de inglês nas escolas de mercado.
                Aulas em grupo com até 15 alunos por sala, contabilizando
                matrícula, mensalidade e materiais.
              </p>
              <button>
                R$ 7.215,00 <span>/ano.</span>
              </button>
            </div>
            <div className="aulas">
              <h3>Aulas individuais:</h3>
              <p>
                Valor anual médio para cursos de inglês nas escolas de mercado
                ou professor particular. Aulas presenciais em casa ou in
                company.
              </p>
              <button>
                R$ 9.600,00 <span>/ano.</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </Duvidas>
  );
}

export default DuvidasComponent;
